import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core'
import { PlatformService } from 'src/app/services/platform.service'
import { environment } from 'src/environments/environment'
import { Store, Select } from '@ngxs/store'
import { Observable, Subject } from 'rxjs'
import { takeUntil, tap, filter } from 'rxjs/operators'
import { SetParticipantData } from 'src/app/store/actions/participant.actions'
import { ParticipantState } from 'src/app/store/state/participant.state'
import { HelpState } from 'src/app/store/state/help.state'
import { HelpSystem } from 'src/app/interfaces/content'
import { EventLogState, EventLogModel, EventLogModelClient } from 'src/app/store/state/event-log.state'
import { LanguageCode } from 'src/app/enums/language'
import { LinkService } from 'src/app/services/link.service'
import { MenuItemOptions } from '../../interfaces/content'
@Component({
  selector: 'mu-login',
  styleUrls: ['./login.page.scss'],
  templateUrl: './login.page.html',
})
export class LoginPage implements OnInit, OnDestroy {
  renderWebview: boolean
  renderAppview: boolean
  production: boolean
  maintenance: boolean
  loginMessage: string
  serviceDeskPage: string
  eventLogClient: EventLogModelClient
  errorLogMessage: string
  eventLogId: string
  maintenanceMessage: string
  @ViewChild('devInput') devInput: ElementRef<HTMLInputElement>

  @Select(EventLogState.clientEventLog)
  eventLogClient$: Observable<EventLogModelClient>
  
  @Select(EventLogState.eventLogId)
  eventLogId$: Observable<string>

  @Select(HelpState.selectedHelpSystem)
  selectedHelpSystem$: Observable<HelpSystem>

  constructor(
    private linkService: LinkService,
    private platform: PlatformService,
    private store: Store,
  ) {}

  ngUnsubscribe = new Subject()


  ngOnInit() {
    this.listenToEventLog()
    this.listenToEventLogId()
    this.listenToHelpSystemChanges()
    this.production = environment.production
    this.maintenance = environment.maintenance
    this.setApplicationView()
    this.loginMessage = this.store.selectSnapshot(ParticipantState).loginMessage
    this.serviceDeskPage = environment.serviceDeskPage
  }

  async signIn() {
    if (this.devInput && this.devInput.nativeElement.value) {
      const prefLang: LanguageCode = this.detectPreferredLanguage()
      this.store.dispatch(
        new SetParticipantData({
          participantId: this.devInput.nativeElement.value,
          languageCode: prefLang,
        })
      )
    }
    const urlParams = new URLSearchParams(window.location.search)
    const module = urlParams.get('module')
    const guid = urlParams.get('guid')
    const goto = guid ? `${module}.${guid}` : module
    const returnUrl = module ? `${environment.callbackUrl}?goto=${goto}` : environment.callbackUrl

    const params = {
      apiKey: environment.authServer.apiKey,
      ReturnUrl: returnUrl,
    }
    const queryString = Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')
    const url = `${environment.authServer.login}?${queryString}`
    const options: MenuItemOptions = {
      external: true,
      attributes: { target: '_self' },
    }
    this.linkService.openUrl(url, options)
  }

  setApplicationView(): void {
    this.renderWebview = this.platform.isWeb()
    this.renderAppview = !this.renderWebview
  }

  detectPreferredLanguage(): LanguageCode {
    if (/^nl\b/.test(navigator.language)) {
      return LanguageCode.NL
    } else {
      return LanguageCode.EN
    }
  }

  allowDevLogin(): boolean {
    return(!environment.production)
  }

  private listenToEventLog() {
    this.eventLogClient$
    .pipe(
      takeUntil(this.ngUnsubscribe),
      tap((event) => {
        if(event.log_level == 'error'){
          this.errorLogMessage = 'login-page.error-message'
        }
      })
    )
    .subscribe()
  }

  private listenToEventLogId() {
    this.eventLogId$
    .pipe(
      takeUntil(this.ngUnsubscribe),
      tap((id) => {
        this.eventLogId = id
      })
    )
    .subscribe()
  }

  private listenToHelpSystemChanges(): void {
    this.selectedHelpSystem$
      .pipe(
        takeUntil(this.ngUnsubscribe),
        filter((help) => !!help.maintenanceHelp && !!help.maintenanceHelp.length),
        tap(async (help) => {
          this.maintenanceMessage = help.maintenanceHelp.map((el) => el.content).join('').replace(/<\/?p>/g, '')
        })
      )
      .subscribe()
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }
}
